/**
 * Recommendations Thunks
 *
 * Async thunks for fetching recommendations
 */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { type OnboardingRecommendations } from '@contracts';
import { submitPreferences as submitPreferencesApi } from '../api/preferencesApi';
import { handleThunkError } from './thunkUtils';

// ============================================
// Types
// ============================================

interface FetchRecommendationsParams {
  destinationIds: string[];
  locale?: string;
}

// ============================================
// Thunks
// ============================================

/**
 * Fetch recommendations based on selected destinations
 */
export const fetchRecommendationsThunk = createAsyncThunk<
  OnboardingRecommendations,
  FetchRecommendationsParams,
  { rejectValue: string }
>(
  'onboarding/fetchRecommendations',
  async ({ destinationIds, locale = 'en-US' }, { rejectWithValue }) => {
    if (destinationIds.length === 0) {
      return rejectWithValue('No destinations selected. Cannot fetch recommendations.');
    }

    try {
      const recommendations = await submitPreferencesApi({
        selectedDestinations: destinationIds,
        locale,
      });
      return recommendations;
    } catch (error) {
      return rejectWithValue(
        handleThunkError(error, 'fetch recommendations', 'Failed to fetch recommendations'),
      );
    }
  },
);
